module.exports = __webpack_public_path__ + "fonts/Montserrat_SemiBold_Latin.6fb1b562.woff2";